import React, {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { useNavigate } from "react-router-dom";

import {
  AppBar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Stack,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  Tooltip,
  Tabs,
  Tab,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  FormControl,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles, styled } from "@mui/styles";

import jwtDecode from "jwt-decode";
import dayjs from "dayjs";
import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import ListPageHeader from "../../utilities/ListPageHeader";
import { confirmAlert } from "react-confirm-alert";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { toast } from "react-toastify";
import { grey } from "@mui/material/colors";
import AsyncSelect from "react-select/async";
import { LinearProgress } from "@material-ui/core";
import moment from "moment";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import FormPageHeader from "../../utilities/FormPageHeader";
import "../expense-claim/expenseClaim.css";

const useStyles = makeStyles((theme) => ({
  root: {
    "& li": {
      padding: "5px 10px",
      cursor: "pointer",

      "&:hover": {
        backgroundColor: grey[800],
      },
    },
    // borderRadius: "20px",
    fontSize: "11px",
    textAlign: "center",
    height: "26px",
    lineHeight: "26px",
    padding: "0px 10px",
    marginTop: "6px",
  },
}));

const currentDate = new Date();

const ActionRenderer = (props) => {
  return (
    <div className="flex item-center">
      <Button color="warning" variant="contained" sx={{ mr: 1 }}>
        Pay
      </Button>
      <Button color="warning" variant="contained">
        {" "}
        View
      </Button>
    </div>
  );
};

export default function GratuityMaster(props) {
  const navigate = useNavigate();
  const classes = useStyles(props);

  const [loanType, setLoanType] = useState([
    { label: "Salary Advance", value: "Salary Advance" },
    { label: "Housing Loan", value: "Housing Loan" },
    { label: "Car Loan", value: "Car Loan" },
    { label: "Personal Loan", value: "Personal Loan" },
    { label: "Other Loans", value: "Other Loans" },
  ]);

  const [rowOpen, setRowOpen] = useState(false);

  const installmentOption = [
    { label: "Monthly", value: "Monthly" },
    { label: "Quartely", value: "Quartely" },
    { label: "Semi Annually", value: "Semi Annually" },
  ];

  const [rowData, setRowData] = useState([
    {
      fileNo: "1",
      description: "Receipt",
      fileType: "PDF",
      filePath: "D:/container_info.txt",
    },
    {
      fileNo: "2",
      description: "Receipts",
      fileType: "PDF",
      filePath: "D:/container_info.txt",
    },
  ]);

  const gridRef = useRef();

  const [totalClaimed, setTotalClaimed] = useState();
  const [docUpdate, setDocUpdate] = useState(false);
  const [initialState, setInitialState] = useState({
    docNo: null,
    docDate: currentDate,
    creationDate: new Date().toISOString(),
    employeeId: null,
    employeeName: null,
    companyCode: 1,
    companyName: "Nolte FZE",
    remark: null,
    folder: [],
  });

  const [tabValue, setTabValue] = useState("nolte");
  const [rowDataPOR, setRowDataPOR] = useState([
    {
      symbol: "<",
      year: "1",
      pay: null,
    },
    {
      symbol: "<",
      year: "3",
      pay: null,
    },
    {
      symbol: "<",
      year: "5",
      pay: null,
    },
    {
      symbol: ">",
      year: "5",
      pay: null,
    },
  ]);

  const [columnPOR, setColumnPOR] = useState([
    { field: "symbol", headerName: "" },
    { field: "year", headerName: "Year" },
    { field: "pay", headerName: "Pay%" },
  ]);
  const [columnDefs, setColumnDefs] = useState([
    { field: "fromDate", headerName: "From" },
    { field: "toDate", headerName: "To" },
    { field: "noOfDays", headerName: "No.of Days" },
  ]);

  const token = jwtDecode(localStorage.getItem("token"));

  console.log(token.scope);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const loadData = async () => {
    let email = token.email;
    const userDataUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmailIgnoreCase?email=${email}`;
    const result = await OAuthService.getList(userDataUrl);
    const user = result?.data;
    const empId = user?._links.user.href.split("/").pop();

    setInitialState({
      ...initialState,
      employeeName: user?.userName,
      employeeId: empId,
      companyName: user?.companyName,
      companyCode: user?.companyId,
    });
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    setDocUpdate(urlParams.get("id") === null ? false : true);
    if (urlParams.get("id") !== null) {
      const dataUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${
        oAuthServiceConfig.expenseClaimList
      }/${urlParams.get("id")}`;

      const dataVal = await OAuthService.getList(dataUrl);
      let amount = dataVal?.data?.recordList?.map((item) => {
        return item.amount;
      });
      setTotalClaimed(amount);
      setInitialState(dataVal.data);
      // setRowData(dataVal.data.recordList);
    }
  };

  const onGridReady = useCallback((params) => {
    loadData();
  }, []);

  const onBtDeleteRow = useCallback(
    (event) => {
      const selectedRow = [event.node.data];

      confirmAlert({
        title: "Confirm to cancel payment",
        message: "Are you sure to cancel payment ?",
        buttons: [
          {
            label: "Yes",
            onClick: () => {},
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    },
    [gridRef, rowData]
  );
  const getContextMenuItems = useCallback((event) => {
    const result = [
      {
        name: "Edit",
        icon: '<span><i class="material-icons style="font-size: 18px">edit</i></span>',
        action: () => {
          // onBtEdit(event);
        },
      },
      {
        name: "Cancel",
        icon: '<span><i class="material-icons" style="font-size: 18px">cancel</i></span>',
        action: () => {
          onBtDeleteRow(event);
        },
      },
    ];
    return result;
  }, []);

  const handleTabChange = (event, value) => setTabValue(value);

  const onRowDoubleClicked = (params) => {
    handleRowDialogOpen();
  };
  const handleRowDialogOpen = () => {
    setRowOpen(!rowOpen);
  };

  return (
    <>
      <FormPageHeader
        componentName="Gratuity Master"
        pageName={"Gratuity Master"}
        currentPage={"Gratuity Master"}
      />

      <div className="p-4 sm:px-24">
        <Grid container spacing={2} className="items-center">
          <Grid xs={16} item>
            <Stack direction="row" className="flex items-end" spacing={2}>
              <Stack>
                <label>Code</label>
                <TextField
                  className="mb-4 w-[120px]"
                  type="text"
                  required
                  variant="outlined"
                  fullWidth
                />
              </Stack>

              <Stack>
                <label>Description</label>
                <TextField
                  className="mb-4 w-[180px]"
                  type="text"
                  required
                  variant="outlined"
                  fullWidth
                />
              </Stack>

              <Stack>
                <label>Per Day Salary Calculation</label>
                <Stack>
                  <Stack>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="/30"
                        name="radio-buttons-group"
                      >
                        <FormControlLabel
                          value="/Days"
                          control={<Radio />}
                          label={
                            <div className="flex items-center">
                              Monthly Salary*12/
                              <TextField
                                className="ml-4 mr-4 mb-4 w-[50px]"
                                type="text"
                                required
                                variant="outlined"
                                fullWidth
                              />
                              Days
                            </div>
                          }
                        />
                        <FormControlLabel
                          value="/30"
                          control={<Radio />}
                          label="Monthly Salary/30"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Stack>
                </Stack>
              </Stack>
              <Stack>
                <FormGroup>
                  <FormControlLabel control={<Checkbox />} label="Active" />
                  <FormControlLabel
                    control={<Checkbox />}
                    label="Accrue During Vacation"
                  />
                </FormGroup>
              </Stack>
            </Stack>
          </Grid>
          <Grid xs={6} item>
            <label className="mb-2">Pay On Resignation</label>
            <AgGridTable
              hideCheckbox={true}
              rowData={rowDataPOR}
              columnDefs={columnPOR}
              onGridReady={onGridReady}
              gridRef={gridRef}
            />
          </Grid>
          <Grid xs={6} item>
            <label>Per-Day Slabs(Year)</label>
            <AgGridTable
              hideCheckbox={true}
              rowData={rowData}
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              gridRef={gridRef}
            />
          </Grid>
        </Grid>
        <div className="flex justify-end my-10">
          <Button color="warning" variant="contained" sx={{ mr: 1 }}>
            Submit
          </Button>
        </div>
      </div>

      {/* <div className="h-full">
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          sx={{ color: "yellow" }}
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
          className={clsx(classes.root)}
        >
          <Tab label="NOLTE FZE" value={"nolte"} />
          <Tab label="FREE LANCE" value={"free-lance"} />
          <Tab label="IT CONSULTANT" value={"it-consultant"} />
        </Tabs>

        <AgGridTable
          hideCheckbox={true}
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          onRowDoubleClicked={onRowDoubleClicked}
          getContextMenuItems={getContextMenuItems}
        />
      </div> */}
    </>
  );
}
